export default __webpack_public_path__ + "static/media/signup-gauge.b553729f.png";